import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames';
import { bool, number, object, string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonLoader from '../skeleton-loader';

var styles = function styles(_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    item: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing(2),
      height: spacing(6)
    },
    withDivider: {
      borderBottom: "1px solid ".concat(palette.divider),
      '&:last-child': {
        borderBottom: '1px solid transparent'
      }
    }
  };
};

export var ItemPlaceholder = function ItemPlaceholder(props) {
  var classes = props.classes,
      className = props.className,
      itemCount = props.itemCount,
      divider = props.divider,
      SkeletonLoaderProps = props.SkeletonLoaderProps;
  var itemClasses = classNames(classes.item, className, _defineProperty({}, classes.withDivider, divider));
  return React.createElement(React.Fragment, null, Array.from({
    length: itemCount
  }).map(function (value, index) {
    return React.createElement("div", {
      className: itemClasses,
      key: index
    }, React.createElement(SkeletonLoader, SkeletonLoaderProps));
  }));
};
process.env.NODE_ENV !== "production" ? ItemPlaceholder.propTypes = {
  classes: object.isRequired,
  SkeletonLoaderProps: object,
  className: string,
  divider: bool,
  itemCount: number
} : void 0;
ItemPlaceholder.defaultProps = {
  SkeletonLoaderProps: undefined,
  className: null,
  itemCount: 4,
  divider: true
};
export default withStyles(styles, {
  name: 'ItemPlaceholder'
})(ItemPlaceholder);